module.exports = __webpack_public_path__ + "static/media/ivrogne.93698b9a.jpg";